// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"07f8c3b3","286":"3d33dd23","453":"bb0fbe25","848":"2755d192"}[chunkId] + ".chunk.js";
};